<template>
  <el-dialog
      :visible.sync="visible"
      title="上传图片"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <multiple-image-upload v-model="data"></multiple-image-upload>
    <template slot="footer">
      <el-button @click="cancel" size="mini">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="doSubmit()" size="mini">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import MultipleImageUpload from '@/components/MultipleImageUpload'

export default {
  name: 'ImageUploadDialog',
  components: { MultipleImageUpload },
  data () {
    return {
      visible: false,
      data: ''
    }
  },
  methods: {
    init () {
      this.visible = true
    },
    cancel () {
      this.visible = false
    },
    doSubmit () {
      this.$emit('completed', this.data)
      this.cancel()
    },
    clear(){
      this.data=''
    }
  }
}
</script>

<style scoped>

</style>
